import { usePlayerActions, usePlayer } from "@utils/player/core/usePlayer";
import React from "react";
import LBox from "@components/LBox";
import LPressable from "@components/LPressable";
import LText from "@components/LText";
import { useActiveQueueType } from "@utils/player";

import { useMe } from "@hooks/trpc/useMe";
import { shouldShowNavigator } from "./navigatorVisibility";
import type { OnboardingStep } from "types/auth";
import * as Haptics from "expo-haptics";
import { Platform } from "react-native";

const tabs = [
  {
    label: "For You",
    name: "foryou",
  },
  {
    label: "Playlist",
    name: "playlist",
  },
] as const;

const Navigator = () => {
  const playerActions = usePlayerActions();

  const activeQueueType = useActiveQueueType();
  const setActiveQueueType = playerActions.setActiveQueueType;
  const { query: meQuery } = useMe();
  const onboardingStep = meQuery.data?.onboardingStep as
    OnboardingStep | undefined;
  const hasPlaylistItems = usePlayer(
    (s) => !!s.playlistQueue && s.playlistQueue.items.length > 0,
  );

  if (!shouldShowNavigator(onboardingStep, hasPlaylistItems)) {
    return null;
  }

  return (
    <LBox
      flexDirection="row"
      justifyContent="center"
      alignItems="center"
      gap="s4"
      flex={1}
    >
      {tabs.map((tab) => (
        <React.Fragment key={tab.name}>
          <LPressable
            sentryEventName={`exclusives_tab_${tab.name}`}
            key={tab.name}
            fadeEnabled
            hitSlop={10}
            onPress={() => {
              if (Platform.OS !== "web") {
                Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Light).catch(
                  console.error,
                );
              }
              if (activeQueueType !== tab.name) {
                setActiveQueueType(tab.name);
              }
              //               if (tab.name === "playlist") {
              //               }
            }}
          >
            <LBox key={tab.name} gap="s1" alignItems="center">
              <LText
                color={
                  activeQueueType === tab.name
                    ? "white"
                    : "navigatorInactiveLabel"
                }
                variant="h1"
                fontWeight="700"
              >
                {tab.label}
              </LText>

              <LBox
                width={40}
                height={2}
                backgroundColor="white"
                borderRadius="xs"
                opacity={activeQueueType === tab.name ? 1 : 0}
              />
            </LBox>
          </LPressable>
        </React.Fragment>
      ))}
    </LBox>
  );
};

export default Navigator;
